<span
  *ngIf="pictureTag"
  class="tag"
  [ngClass]="'tag--' + pictureTag + (class | addClassList: { mainClass: 'tag--' })"
  id="{{ pictureTagId }}"
>
  {{ pictureTag }}
</span>
